import { useStartupStartedAt, useStartupStatus } from "@noa/client-store";
import { useEffect, useState } from "react";
import { estimateWarmupProgress } from "../utils/warmup";

/** The warmup notice's estimated progress in percent, re-read every second while the API is starting. */
export function useWarmupProgress(): number {
  const status = useStartupStatus();
  const startedAt = useStartupStartedAt();
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    if (status !== "warming") return;
    const interval = setInterval(() => setNow(Date.now()), 1_000);
    return () => clearInterval(interval);
  }, [status]);

  return estimateWarmupProgress(startedAt, now);
}
